var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        "before-close": _vm.closeDialog,
        "show-close": _vm.active == 3 || _vm.isAllFailed,
        visible: _vm.isShow,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        width: "711px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c("printWarningTip", {
        attrs: {
          dyAlertTitle: _vm.dyAlertTitle,
          selectPrinterForm: _vm.formInfo,
        },
      }),
      _c("div", { staticClass: "y-f y-f-jb y-f-a print-step" }, [
        _c("div", { staticClass: "step1 y-t-ac" }, [
          _c("div", { staticClass: "y-mb-5 y-p-r" }, [
            _vm.active == 1
              ? _c("div", { staticClass: "print-text-icon text-active" }, [
                  _vm._v("1"),
                ])
              : _c("img", {
                  staticClass: "print-step-icon",
                  attrs: {
                    src: require("@/assets/images/dianshang/printFinish.png"),
                  },
                }),
            _c("div", {
              staticClass: "print-line",
              class: { "active-border": _vm.active == 2 || _vm.active == 3 },
            }),
          ]),
          _c("span", { class: { "process-blue": _vm.active == 1 } }, [
            _vm._v("获取运单数据"),
          ]),
        ]),
        _c("div", { staticClass: "step2 y-t-ac" }, [
          _c("div", { staticClass: "y-mb-5 y-p-r" }, [
            _vm.active !== 3
              ? _c(
                  "div",
                  {
                    staticClass: "print-text-icon wait-gray",
                    class: { "text-active": _vm.active == 2 },
                  },
                  [_vm._v("2")]
                )
              : _c("img", {
                  staticClass: "print-step-icon",
                  attrs: {
                    src: require("@/assets/images/dianshang/printFinish.png"),
                  },
                }),
            _c("div", {
              staticClass: "print-line",
              class: { "active-border": _vm.active == 3 },
            }),
          ]),
          _c(
            "span",
            {
              class: {
                "process-blue": _vm.active == 2,
                "wait-gray-text": _vm.active == 1,
              },
            },
            [_vm._v("开始打印")]
          ),
        ]),
        _c("div", { staticClass: "step3 y-t-ac" }, [
          _c("div", { staticClass: "y-mb-5" }, [
            _vm.active != 3
              ? _c("div", { staticClass: "print-text-icon wait-gray" }, [
                  _vm._v("3"),
                ])
              : _c("img", {
                  staticClass: "print-step-icon",
                  attrs: {
                    src: require("@/assets/images/dianshang/printSuccess.png"),
                  },
                }),
          ]),
          _c(
            "span",
            {
              class: {
                "process-blue": _vm.active == 3,
                "wait-gray-text": _vm.active != 3,
              },
            },
            [_vm._v("打印成功")]
          ),
        ]),
      ]),
      _vm.active == 1 && !_vm.isApplyOrderFinished
        ? _c("div", { staticClass: "tip-desp" }, [
            _vm._v("正在为："),
            _c("span", { staticClass: "y-fc-4C84FF" }, [
              _vm._v(_vm._s(_vm.curOrderNumber)),
            ]),
            _vm._v(" 获取运单数据，等待中请勿操作当前页面"),
          ])
        : _vm._e(),
      _vm.active == 2
        ? _c(
            "div",
            { staticClass: "tip-desp y-fs-16" },
            [
              _c("div", [_vm._v("正在向打印机发送数据......")]),
              _c("el-progress", {
                staticStyle: { width: "400px", margin: "0 auto" },
                attrs: { percentage: _vm.printPercentage, "stroke-width": 8 },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.active == 3
        ? _c("div", { staticClass: "tip-desp y-fs-16" }, [
            _vm._v("打印机打印完成后，如发现漏打情况，您可在 "),
            _c("span", { staticClass: "y-fc-4C84FF" }, [
              _vm._v("统计分析-打印记录"),
            ]),
            _vm._v(" 页面中查看该批次详情，补打漏单"),
          ])
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px", "text-align": "center" } },
        [
          _vm.active == 3 || _vm.isAllFailed
            ? _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.closeDialog } },
                [_vm._v("关闭")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }